import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InfoParams } from './info';

@Component({
  templateUrl: 'blockingdialog.component.html',
  styleUrls: ['dialog.component.scss'],
  standalone: false,
})
export class BlockingDialogComponent {
  data = inject<InfoParams>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<BlockingDialogComponent>>(MatDialogRef);

  trustedHtml: SafeHtml;

  constructor() {
    const data = this.data;
    const sanitizer = inject(DomSanitizer);

    this.trustedHtml = sanitizer.bypassSecurityTrustHtml(data.message);
  }
}
